// import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// export const baseQuery = fetchBaseQuery({
//   baseUrl: process.env.REACT_APP_BASE_URL,
//   prepareHeaders: (headers) => {
//     const token = localStorage.getItem("token"); 
//     if (token) {
//       headers.set("Authorization", `Bearer ${token}`); 
//     }
//     return headers;
//   },
// });


import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_AUTH_BASE_URL,
});

export const appBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});